import * as React from "react";

const ImageErrorContainer = ({ error }) => (
  <p>
    <span className="fa fa-exclamation-triangle" aria-hidden="true" />
    &nbsp;{error}
  </p>
);

export default ImageErrorContainer;